module.exports = __webpack_public_path__ + "static/media/designer-picker-illustration.70dc5299.png";